function popUp(popUpOpen, popUp, popUpClose) {
    if (document.querySelectorAll(popUpOpen).length > 0) {
        const quickAddBtn = document.querySelectorAll(popUpOpen),
        packsPopup = document.querySelectorAll(popUp),
        popupCloseBtn = document.querySelectorAll(popUpClose);
        for (let i = 0; i < quickAddBtn.length; i++) {
            quickAddBtn[i].addEventListener('click', () => {
                packsPopup[i].classList.add('visible');
            });
            popupCloseBtn[i].addEventListener('click', () => {
                packsPopup[i].classList.remove('visible');
            });
        }
    }
}
popUp('.quick-add-btn', '.preview-packs__popup', '.popup-close-btn');
popUp('.js-about-product__popup-open', '.js-about-product__popup', '.js-about-product__popup-close');
popUp('.js-product-bundle__popup-open', '.js-product-bundle__popup', '.js-product-bundle__popup-close');


// Fixed Auto-Play on Safari
document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelectorAll('video:not(.player-media)').length > 0) {
        var promise = document.querySelector('video:not(.player-media)').play();

        if (promise !== undefined) {
            promise.catch(error => {
                console.log('Auto-play was prevented');
                let video = document.querySelector('video:not(.player-media)');
                video.play();
            }).then(() => { 
                console.log('Auto-play started');
            });
        }
    }
});

document.querySelectorAll('.play-video').forEach(e=> {
    e.addEventListener('click', function(evt) {
        const parent = e.closest('.video-player')
        const video = parent.querySelector('.player-media')
        const poster = parent.querySelector('.cover-image')

        video.removeAttribute('hidden')
        video.querySelector('video').play()
        video.querySelector('video').play()
        poster.setAttribute('hidden','')
        e.setAttribute('hidden','')
    })
})

$('.slider-grid').each(function() {
    $(this).slick({
        mobileFirst: true,
        arrows: true,
        focusOnSelect: true,
        slidesToShow: Number($(this).attr('data-slide-to-show')),
        slidesToScroll: Number($(this).attr('data-slide-to-scroll')),
        infinite: false, 
        autoplay: false,
        swipe: true, 
        centerMode: true,
        variableWidth: true,
        initialSlide: Number($(this).attr('data-initial-slide')),
        responsive: [
            {
                breakpoint: 767,
                settings: "unslick"
            }
        ]
    });
});

$('.hover-grid').each(function() {
    $(this).slick({
        mobileFirst: true,
        arrows: true,
        focusOnSelect: true,
        slidesToShow: Number($(this).attr('data-slide-to-show')),
        slidesToScroll: Number($(this).attr('data-slide-to-scroll')),
        infinite: false, 
        autoplay: false,
        swipe: true, 
        centerMode: true,
        variableWidth: false,
        initialSlide: Number($(this).attr('data-initial-slide')),
        responsive: [
            {
                breakpoint: 767,
                settings: "unslick"
            }
        ]
    });
});


$('.slider-carousel').each(function() {
    $(this).slick({
        arrows: false,
        slidesToScroll: Number($(this).data('slide-to-scroll')),
        slidesToShow: 5,
        infinite: true, 
        autoplay: false,
        initialSlide: 1,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    dots: false,
                    infinite: true,
                    centerMode: true
                }
            }
        ],
    });
});

$('.order-variants-grid.slick-initialized')?.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    checkedOpt(slick,nextSlide)
});

$('.order-variants-grid.slick-initialized')?.on('swipe', function(event, slick, direction){
    console.log(Number(slick.$slider[0].querySelector('.slick-current').dataset.slickIndex))
    checkedOpt(slick,Number(slick.$slider[0].querySelector('.slick-current').dataset.slickIndex))
});

function checkedOpt(slick,nextSlide) {
    
    const current = slick.$slides[nextSlide]
    const clickEvent = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
    });

    if (current ==null) return;
    
    document.querySelectorAll('.order-variant').forEach(e=> {
        e.classList.remove('active')
    })

    current.querySelector('.order-variant').classList.add('active')
}




if (document.querySelector('.append-about-slide') != null && document.querySelector('.slider-about-carousel') != null) {
    document.querySelector('.append-about-slide') .appendChild(document.querySelector('.slider-about-carousel'))
    setTimeout( function() {
        $('.slider-about-carousel').slick({
            arrows: true,
            slidesToScroll: Number($(this).data('slide-to-scroll')),
            slidesToShow: 1,
            autoplay: false,
            swipe: true,
            swipeToSlide: true,
            infinite: false,
            responsive: [
              {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: false,
                    dots: false
                }
              }
            ],
        });
    },200)
}

// Get all anchor elements
var anchorElements = document.querySelectorAll('a');

// Loop through the anchor elements
anchorElements.forEach(function(anchor) {
    // Check if the href attribute contains #
    if (anchor.getAttribute('href') && anchor.getAttribute('href').includes('#')) {
        anchor.addEventListener('click', function(event) {
            event.preventDefault();

            // Get the target ID from the href
            var targetId = anchor.getAttribute('href').substring(1); // Remove the #

            // Check if an element with the target ID exists in the DOM
            var targetElement = document.getElementById(targetId);

            if (targetElement) {
                // Define an offset (adjust this value as needed)
                var offsetTop = 50; // Change this to your desired offset

                // Scroll to the target element with the specified offset
                window.scrollTo({
                    top: targetElement.offsetTop - offsetTop,
                    behavior: 'smooth' // You can change this to 'auto' for an instant scroll
                });
            }
        });
    }
});

document.querySelectorAll('.junip-scroll').forEach(e=> {
    e.addEventListener('click', function() {
        // Check if an element with the target ID exists in the DOM
        var targetElement = document.querySelector('.junip-review-section');
        
        if (targetElement) {
            // Define an offset (adjust this value as needed)
            var offsetTop = 50; // Change this to your desired offset

            // Scroll to the target element with the specified offset
            window.scrollTo({
                top: targetElement.offsetTop - offsetTop,
                behavior: 'smooth' // You can change this to 'auto' for an instant scroll
            });
        }
    })
})

var linkToggle = document.querySelectorAll('.js-toggle');

for(i = 0; i < linkToggle.length; i++) {
    linkToggle[i].addEventListener('click', function(event) {

    event.preventDefault();
    
    var container = document.getElementById(this.dataset.container);

    if (!container.classList.contains('active')) {
        this.classList.add('is-open');
        container.classList.add('active');
        container.style.height = 'auto';

        var height = container.clientHeight + 'px';

        container.style.height = '0px';

        var parentContainer = container.closest('.sub-parent')


        setTimeout(function () {
        container.style.height = height;
            if (parentContainer != undefined && parentContainer.clientHeight > 0) {
            setTimeout( function() {
                parentContainer.style.height = 'auto';
                var parentHeight = parentContainer.clientHeight + 'px';
        
                parentContainer.style.height = '0px';

                parentContainer.style.height = parentHeight;
            }, 100)
            }
        }, 0);
        
    } else {
        this.classList.remove('is-open');
        
        container.style.height = '0px';

        if (container.classList.contains('no-trans')) {
        container.classList.remove('active');
        } else {
        container.addEventListener('transitionend', function () {
            container.classList.remove('active');
        }, {
            once: true
        });
        }
        
        setTimeout(function () {
        var parentContainer = container.closest('.sub-parent')
        var innerSub = container.closest('.inner-sub')

        if (innerSub != null) {
            parentContainer.style.height = innerSub.clientHeight + 'px';
        }
        }, 100);
    }
    
    });

}